import { InlineNoteInput } from './InlineNoteInput';

interface NoteFieldProps {
  note: string | undefined;
  isEditing: boolean;
  onNoteChange: (note: string) => void;
  onStartEditing: () => void;
  onStopEditing: () => void;
  readOnly?: boolean;
}

export function NoteField({
  note,
  isEditing,
  onNoteChange,
  onStartEditing,
  onStopEditing,
  readOnly = false,
}: NoteFieldProps) {
  // In readOnly mode, only show the note text if it exists
  if (readOnly) {
    if (note) {
      return (
        <p className="text-xs text-gray-500 mt-1 italic">
          {note}
        </p>
      );
    }
    return null;
  }

  if (note || isEditing) {
    return (
      <InlineNoteInput
        value={note || ''}
        onChange={onNoteChange}
        onClose={onStopEditing}
      />
    );
  }

  return (
    <button
      onClick={onStartEditing}
      className="text-xs text-gray-400 hover:text-gray-600 mt-1"
    >
      ✎ Add note
    </button>
  );
}
